"use client"

import { useEffect } from "react"
import { ErrorFeedback } from "src/components/common/ErrorFeedback"
import { MinimalLayout } from "src/components/layout/MinimalLayout"
import { DEFAULT_COUNTRY_CODE } from "src/localization/localization"
import { fontClassName } from "src/styles/fonts"
import { ErrorBoundaryProps } from "src/types/page"
import { recordError } from "src/utilities/errorReporting"

export default function GlobalErrorPage({ error }: ErrorBoundaryProps) {
  useEffect(() => {
    recordError("src/app/global-error.tsx page was shown", error)
  }, [error])

  return (
    <html lang={DEFAULT_COUNTRY_CODE}>
      <body className={fontClassName}>
        <MinimalLayout>
          <ErrorFeedback />
        </MinimalLayout>
      </body>
    </html>
  )
}
